import {
    Text,
    makeStyles,
    mergeClasses,
    tokens,
} from '@fluentui/react-components';
import { Column, Row } from '../common';
import { Note, UserAccount, UserRef } from '../../data/types';
import { useCommonStyles } from '../common/Styles/commonStyles';
import { useUserUtilities } from '../../utilities/useUserUtilities';
import { useAccountState } from '../../redux/reducers/accountReducer';
import { PersonControl } from './PersonControl';
import { appTokens } from '../common/Styles/appTokens';

const useStyles = makeStyles({
    root: {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        width: '100%',
        maxWidth: '95%',
        backgroundColor: tokens.colorNeutralBackground2,
    },
    createdBy: {
        //color: tokens.colorBrandForeground1,
        pointerEvents: 'none',
        userSelect: 'none',
    },
    right: {
        maxWidth: '85%',
        alignSelf: 'flex-end',
        backgroundColor: appTokens.noteControl.others,
    },
    left: {
        maxWidth: '85%',
        alignSelf: 'flex-start',
        backgroundColor: appTokens.noteControl.self,
    },
});
export type NoteControlProps = {
    className?: string;
    note?: Note;
    right?: boolean;
    left?: boolean;
};
export const NoteControl = (props: NoteControlProps) => {
    const { className, note, right, left } = props;

    //Hooks
    const { primaryAccount } = useAccountState();
    const { accountUsers } = (primaryAccount as UserAccount) ?? {};
    const utils = useUserUtilities();

    //Styles
    const commonStyles = useCommonStyles();
    const styles = useStyles();
    const controlClasses = mergeClasses(
        styles.root,
        right && styles.right,
        left && styles.left,
        className,
    );
    const createdByClasses = mergeClasses(
        styles.createdBy,
        commonStyles.text.subtleText,
    );

    //Logic
    const getCreatedOn = () => {
        if (!!note?.lifecycle?.createdOn) {
            const createdOn = new Date(note?.lifecycle?.createdOn);
            return `${createdOn.toLocaleDateString(undefined, {month:'short', day:'numeric', year:'numeric'})} ${createdOn.toLocaleTimeString()}`;
        }
    };
    const getUser = (userId?: string) => {
        return accountUsers?.find((user) => user.userId === userId) ?? deletedUser;
    };

    const deletedUser: UserRef = {
        name: '(deleted user)',
        userId: '',
        username: '',
    };

    return (
        <Column
            className={controlClasses}
            height='auto'
            subtleBorder
            borderRadius='6px'
            gap='medium'
            padding='px-2 py-2'
            minHeight='fit-content'
        >
            <Row>
                <Column vAlign='top' align='left'>
                    <PersonControl person={getUser(note?.lifecycle?.createdBy)} size='small-option' />
                </Column>
                <Column vAlign='top' align='right'>
                    <Text size={200} italic className={createdByClasses}>
                        {!!note?.lifecycle?.createdBy && getCreatedOn()}
                    </Text>
                </Column>
            </Row>
            <Column padding='pl-3'>
                <Text>{note?.text}</Text>
            </Column>
        </Column>
    );
};
